import { useContext } from "react";
import { useSelector } from "react-redux";
import {
  Identifiable,
  Project,
  Zone,
  ZoneProjectsRetrievalError,
  ZoneProjectsRetrievalFilter,
} from "@planzone/dto";
import { Boundaries } from "@planzone/core";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  projects: Identifiable<Project>[];
  error: ZoneProjectsRetrievalError;
  canRetrieveNextProjects: boolean;
  callCount: number;
  retrieveZoneProjects(
    request: Boundaries["retrieveZoneProjects"]["request"],
  ): void;
}

function useZoneProjectsRetrieval(
  zone: Identifiable<Zone>,
  filter: ZoneProjectsRetrievalFilter,
): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isZoneProjectsRetrievalRequestPending(zone, filter),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isZoneProjectsRetrievalRequestSuccess(zone, filter),
    ),
    isRequestFailure: useSelector(() =>
      selector.isZoneProjectsRetrievalRequestFailure(zone, filter),
    ),
    projects: useSelector(() => selector.getZoneProjects(zone, filter)),
    error: useSelector(() =>
      selector.getZoneProjectsRetrievalError(zone, filter),
    ),
    canRetrieveNextProjects: useSelector(() =>
      selector.canRetrieveNextZoneProjects(zone, filter),
    ),
    callCount: useSelector(() =>
      selector.getZoneProjectsCallCount(zone, filter),
    ),
    retrieveZoneProjects: core.retrieveZoneProjects,
  };
}

export { useZoneProjectsRetrieval };
